/**
 * EcoInnovations Blake ATC prefs:
 * /products/* Add to cart → /checkout (no cart drawer, no sticky).
 */
(function () {
  var path = window.location.pathname || '';
  if (path.indexOf('/products/') !== 0) return;

  function goCheckout() {
    window.location.assign('/checkout');
  }

  function closeDrawer() {
    var d = document.querySelector('theme-drawer#cart-drawer');
    if (!d) return;
    try {
      if (typeof d.close === 'function') d.close();
    } catch (e) {}
    d.removeAttribute('open');
  }

  // Intercept cart add XHR/fetch — most reliable across Horizon versions
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var req = origFetch.apply(this, arguments);
      if (String(url).indexOf('/cart/add') !== -1) {
        return req.then(function (res) {
          var clone = res.clone();
          clone
            .json()
            .then(function (data) {
              if (data && data.status) return; // Shopify error shape
              closeDrawer();
              goCheckout();
            })
            .catch(function () {
              // Non-JSON success still means item likely added
              if (res.ok) {
                closeDrawer();
                goCheckout();
              }
            });
          return res;
        });
      }
      return req;
    };
  }

  // If drawer still opens, bounce to checkout
  function watchDrawer() {
    var d = document.querySelector('theme-drawer#cart-drawer');
    if (!d || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (d.hasAttribute('open')) {
        closeDrawer();
        goCheckout();
      }
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
})();
